
const STATIC_WEB_HOST = 'www.promocards.io';
// const STATIC_WEB_HOST = '127.0.0.1:5000';
// const STATIC_WEB_HOST = 'http://localhost:3000';

export default STATIC_WEB_HOST;
